import React from 'react'
import cardData from './CardData'
import style from './card.module.css'
import { Row, Col, Card, Typography, Avatar, Divider } from 'antd';
import 'antd/dist/antd.css';
import 'font-awesome/css/font-awesome.min.css';

const { Title, Text } = Typography;
const TeacherComponent = () => {

    return (
        
        <div className={style.back}>
       <div className={style.techerCntainer} id="teachers">  
       <Text className={style.paragraph}>
                     <p>
                    OUR PROFESSIONAL
                    </p>
            </Text>   
        <Title className={style.sectionHeading}>Our Awesome Teachers</Title>

            <div className={style.cardMainContainer}>
                <div className={style.mainCon}>
                    <div className={style.main}>
                        <Row justify="center" gutter={[{ xs: 8, sm: 16, md: 24, lg: 32, xl: 16 }, 40]} >
                            {cardData.map(item =>
                                <Col className={style.tchCrd} xs={24} sm={12} md={12} lg={8} xl={6}>
                                    <Card className={style.teacherCard} hoverable>
                                    <Divider className={style.edusolDivider}>   
                                    <Avatar className={style.teacherCardImg} size={100} src={item.image} />
                                    </Divider>
                                        <div className={style.cardMain}>



                                            <div className={style.TeacherHomeName}>
                                                <h3>{item.name}</h3>
                                            </div>
                                            {/*  <div className={style.roleDes}>
                            <h4>{item.roledescription}</h4>
                        </div> */}
                                            <div className={style.qualification}>
                                                <p>{item.qualification}</p>
                                            </div>
                                            <div className={style.socialNetworks}>
                                                <a href="https://www.facebook.com/" className={style.iconFacebook}>Facebook</a>
                                                <a href="https://twitter.com/" className={style.iconTwitter}>Twitter</a>
                                                <a href="https://github.com" className={style.iconGithub}>GitHub</a>
                                                <a href="https://www.linkedin.com/" className={style.iconLinkedin}>Linkedin</a>
                                                <a href="https://www.instagram.com/" className={style.iconInsta}>Instagram</a>
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    </div>
     
    )
}

export default TeacherComponent